import React, { Component } from 'react';
import { isEmpty, getGuestRoomIcon } from '../../Common/Common';
import Button from '../../Part_Sample/Button';
import ConfirmMessage from '../../Part_Sample/ConfirmMessage';

export default class Guest_Room_Cell extends Component {
	constructor(props) {
		super(props);
		/* Eg. {unit name: 
		 * 			{"connected":true/false, 
		 * 			 "rent_stat": "on"/"off", 
		 * 			 "occ_stat":"on"/"off", 
		 * 			 "rem_rent_op": true/false},
		 *  …}
		*/
		this.state = {
			is_show_confirm: false,
		}
	}

	toggleCheckIn = () => {
		this.setState({ is_show_confirm: true })
		if (this.props.room_details.connected && this.props.room_details.rem_rent_op) {
			this.setState({ is_show_confirm: true });
		}
	}

	onConfirm = (is_pressed_ok) => {
		this.setState({ is_show_confirm: false })
		if (is_pressed_ok) {
			let rental_details = {};
			let new_stat = 'on';
			if (this.props.room_details.rent_stat == 'on') {
				new_stat = 'off'
			}

			rental_details[this.props.room_details.room_name] = new_stat;
			this.props.receiver.setRoomRental(rental_details);
		} else {
			return;
		}
	}

	rcvSetRoomRental = (response) => {
		if (response.result != 'OK') {
			window.app.showToast(this.props.receiver.getString('set_fail'), 3000);
		}
	}

	render() {
		let cell_width = 135;

		let style = {
			display: 'inline-block',
			verticalAlign: 'top',
		}

		let is_occupied = false;
		let is_rented = false;
		let is_display_button = true;
		let confirm_message = '';

		if (!isEmpty(this.props.room_details)) {
			if (this.props.room_details.occ_stat == 'on') is_occupied = true;
			if (!this.props.room_details.connected) is_display_button = false;
			if (!this.props.room_details.rem_rent_op) is_display_button = false;

			if (this.props.room_details.rent_stat == 'on') {
				is_rented = true;
				confirm_message = this.props.receiver.getString('check_out') + ': ' + this.props.room_details.room_name + '?'
			} else {
				confirm_message = this.props.receiver.getString('check_in') + ': ' + this.props.room_details.room_name + '?'
			}
		}

		if (this.props.is_disabled) is_display_button = false;

		let bg_color = 'white';
		if (is_occupied) bg_color = '#f0d18F';
		if (!this.props.room_details.connected) bg_color = '#b2b2b2ad';

		let cell_style = {
			cursor: 'pointer',
			width: cell_width,
			height: cell_width,
			margin: 5,
			padding: 5,
			backgroundColor: bg_color,
			borderRadius: 20,
			boxShadow: '1px 1px 2px 2px rgba(0, 0, 0, 0.1)',
			zIndex: 1,
			opacity: this.props.room_details.connected ? 1 : 0.5,
		}

		let icon = getGuestRoomIcon(this.props.room_details.icon);

		let button_bg_color = !is_rented ? this.props.colours.appBlue : this.props.colours.midnight_sky;
		let label = !is_rented ? this.props.receiver.getString('check_in') : this.props.receiver.getString('check_out');

		return (
			<div style={style} id={this.props.id + '_cell_external'}>
				<ConfirmMessage
					is_show={this.state.is_show_confirm}
					message={confirm_message}
					width={this.props.width}
					height={this.props.height}
					receiver={this.props.receiver}
					handleClick={this.onConfirm}
					style={{ top: 0, left: 0 }}
				/>
				<div id={this.props.id + '_cell_internal'} style={cell_style} onClick={this.handleRentOperation} className='flipInY'>
					<div style={{ marginLeft: 10 }}>
						<span>{this.props.room_details.room_name}</span>
					</div>
					<div style={{ textAlign: 'center' }}>
						<img src={icon} style={{ width: 75 }} />
					</div>

					<div style={{ display: is_display_button ? 'block' : 'none', width: cell_width, marginRight: 'auto', marginLeft: 'auto', marginTop: 5 }}>
						<Button
							id={this.props.room_details.room_name}
							style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', color: this.props.colours.button_font, borderRadius: 20, margin: 0, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center', minHeight: 0, }}
							bgColor={button_bg_color}
							onClick={this.toggleCheckIn}>{label}
						</Button>
					</div>
				</div>
			</div>

		)
	}
}
